var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-thumbnail",class:_vm.activeClass},[_c('img',{attrs:{"src":_vm.renderImage,"alt":(_vm.text + " thumbnail")}}),_c('div',{staticClass:"flex-thumbnail__text"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }